import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

const defaultItemActiveColorVars = {
  '--tabs-item-color': m('--action-default-color'),
  '--tabs-item-active-underline-color': m('--action-active-color'),
  '--tabs-item-hover-color': m('--action-hover-color'),
  '--tabs-item-active-color': m('--action-active-color'),
};

export const lightTabVars: MotifComponentProps<MotifComponent.TABS> = {
  '--tabs-underline-color': m('--neutral-v250'),
  ...defaultItemActiveColorVars,
};

export const darkTabVars: MotifComponentProps<MotifComponent.TABS> = {
  '--tabs-underline-color': m('--neutral-v600'),
  ...defaultItemActiveColorVars,
  '--tabs-item-active-color': m('--primary-v100'),
};
